import { render, staticRenderFns } from "./SithMesCustomerList.vue?vue&type=template&id=f0084d94&"
import script from "./SithMesCustomerList.vue?vue&type=script&lang=js&"
export * from "./SithMesCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports